import { Loadable } from '../../Loadable';

export const AsyncAddVenueOperator = Loadable(() => import('./Add'));
export const AsyncEditVenueOperator = Loadable(() => import('./Edit'));
export const AsyncVenueOperators = Loadable(() => import('./List'));
